<template>
	<inertia-head title="TRC COUPLE HOME" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h3 class="fw-bold text-white mb-2">
						{{
							`Welcome to the ${$page.props.app.name} - Couple`
						}}
					</h3>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						TRC Couple Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div v-if="is_expired=='Yes'">
			<div class="block mb-0 border-bottom" >
				<div class="block-content block-content-full text-center">
					<p class="h4">Your subscription is already expired, please renew your TRC Couple. Click the button below.</p>
					<div class="mt-4">
						<inertia-link href="/member/trc-couple/renew" class="fs-xs btn btn-info"><i class="fa fa-arrow-circle-up me-2"></i>TRC Couple Renewal</inertia-link>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="row">
			<div v-if="$page.props.welcome_vimeo_id!=null && $page.props.welcome_vimeo_id!=0" class="col-12 mb-7">
	        	<h1 class="text-center mb-2">Welcome Video</h1>
	            <div class="embed-responsive">
	                <iframe class="shadow-sm embed-responsive-item" :src="'https://player.vimeo.com/video/'+$page.props.welcome_vimeo_id" allowfullscreen></iframe>
	            </div>
	        </div>

	        <div v-if="announcements.length>0" class="col-12 mb-6">
				<h4 class="mb-0 border-bottom border-3 border-danger">Announcements</h4>
				<div v-for="(announcement,a_index) in announcements" class="block mb-0 border-bottom" :class="{'border-top':a_index>0}">
					<div class="block-content block-content-full">
						<div class="fw-semibold h2 mb-0">{{announcement.title}}</div>
						<div class="fs-xs text-muted fst-italic">{{announcement.posted_date}}</div>
		                <div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="announcement.description">
			                
			            </div>
		                <div v-if="announcement.announcement_img_url!==null" class="mt-5 text-center overflow-hidden">
		                	<img :src="announcement.announcement_img_url" class="img img-fluid" />
		                </div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		user 			: Object,
		is_expired 		: String,
		announcements 	: Object,
		flash 			: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

	},
}
</script>
